import CtaBoxesWithDescription from './ctaBoxesWithDescription';

export default CtaBoxesWithDescription;
